import { ItemDaVenda, Venda } from '@/models'
import pdfMake from 'pdfmake/build/pdfmake'
import type { Content, ContentText, TDocumentDefinitions } from 'pdfmake/interfaces'
import vfs from 'pdfmake/build/vfs_fonts.js'
import print from 'print-js'
import { displayNomeCompletoDoProduto } from '../produto-shareds'
import JsBarcode from 'jsbarcode'
import { dateTimeToPtBrFormat } from '../date/date-utils'

function textToBase64Barcode(text: string){
	const canvas = document.createElement("canvas");
	JsBarcode(canvas, text, {
		height: 60,
		fontSize: 15,
		displayValue: true,
	});
	return canvas.toDataURL("image/png");
}

window.pdfMake.vfs = vfs.pdfMake.vfs;
export async function gerarRomaneio (venda: Venda, qrData: string): Promise<string> {
	const loja = venda.pontoDeVenda?.loja || null
	const dataHoraDaNota = venda.notas.filter(({cstat}) => cstat === '100').flatMap(nota => nota.dhEmi)
	const produtos = venda.itens.filter((item) => item.motivoCancelamento === null)
	const docDefinition: TDocumentDefinitions = {
		pageSize: 'A4',
		content: [
			{
				table: {
					widths: ['*'],
					body: [
						[
							{
								columns: [
									{ text: 'ROMANEIO', fontSize: 16,  style: 'tableHeader', width: 'auto', bold: true },
									{ text: `${loja?.nomeFantasia || ''}`, fontSize: 11, style: 'tableHeader', width: '*', bold: true, alignment: 'center', margin: [0, 4, 0, 0 ] },
									{ text: `${venda.identificador}`, fontSize: 15, style: 'tableHeader', width: 'auto', bold: true },
								],
							},
						],
						[{
							stack: [
								[ 'CLIENTE:', venda.cliente?.razaoSocialOuNome ],
								[ 'CPF/CNPJ:', venda.cliente?.cnpjOuCpf ],
								[ 'ENDEREÇO:', `${venda.cliente?.endereco.rua} Nº ${venda.cliente?.endereco.numero}` ],
								[ 'COMPLEMENTO:', venda.cliente?.endereco.complemento ],
								[ 'BAIRRO:', venda.cliente?.endereco.bairro ],
								[ 'CIDADE:',  `${venda.cliente?.endereco.cidade} - ${venda.cliente?.endereco.uf}`],
								[ 'CEP:',  `${venda.cliente?.endereco.cep}`],
								[ 'TELEFONE:', venda.cliente?.telefones.length === 0 ? 'Não consta' : venda.cliente?.telefones ],
								[ 'DATA DA VENDA:',  venda.dataHora ? dateTimeToPtBrFormat(venda.dataHora) : ''],
								[ dataHoraDaNota.toString() != '' ?  'DATA DE FATURAMENTO:' : '', dateTimeToPtBrFormat(dataHoraDaNota.toString())],
							].map(([ campo, valor ]) => ({
								columns: [
									{ text: campo, bold: true, width: 'auto', margin: [0, 0, 5, 0 ] },
									{ text: valor },
								],
								listType: 'none',
							})),
						}],
					],
				},
				margin: [0, 0, 0, 10],
			},
			{ image: textToBase64Barcode(venda.identificador || ''), alignment: 'center' },
			buildTabelaItensDaVenda(produtos || [],
				[
					{text: 'sku', bold: true, fontSize: 7 },
					{text: 'nome', bold: true, fontSize: 7 },
					{text: 'quantidade', bold: true, fontSize: 7 },
				],
			),
			buildLinhasDeVolume(venda.volumes),
			{ 
				qr: qrData,
				alignment: 'center',
				fit: 150,
				margin: [0, 50, 0, 0],
			},
		],
	};
	return new Promise(resolve => {
		pdfMake.createPdf(docDefinition).getBase64((result) => resolve(result))
	})
}

function buildTabelaItensDaVenda(itensDaVenda: ItemDaVenda [], colunas: ContentText[]): Content {
	return {
		table: {
			widths: [ 85, '*', 65 ],
			headerRows: 1,
			body: buildLinhasItensDaVenda(itensDaVenda, colunas),
		},
	}
}

function buildLinhasItensDaVenda(itensDaVenda: ItemDaVenda [], colunas: ContentText[],
): any[]{
	const body: ContentText[][] = []
	body.push([
		{ text: 'Codigo', bold: true, fontSize: 10 },
		{ text: 'Produto', bold: true, fontSize: 10 },
		{ text: 'Qtde', bold: true, fontSize: 10 },
	])

	const itensDaVendaAgrupados: any = []
	itensDaVenda.forEach((item) => {
		const indice = itensDaVendaAgrupados.findIndex(
			({ nome }) => nome === item.produto.nome,
		)
		indice === -1
			? itensDaVendaAgrupados.push({
				nome: item.produto.nomeCompleto || displayNomeCompletoDoProduto(item.produto),
				quantidade: item.quantidade,
				sku: item.produto.sku,
			})
			: itensDaVendaAgrupados.splice(indice, 1, {
				...itensDaVendaAgrupados[indice],
				quantidade: item.quantidade + itensDaVendaAgrupados[indice].quantidade,
			})
	})

	itensDaVendaAgrupados.forEach(itemDaVenda => {
		const dados: ContentText[] =[]
		colunas.forEach(coluna => {
			let conteudoDaLinha = itemDaVenda[coluna.text as string]
			if(coluna.text === 'sku') conteudoDaLinha = itemDaVenda.sku
			if(coluna.text === 'nome') conteudoDaLinha = itemDaVenda.nome
			dados.push({
				text: conteudoDaLinha, bold: false, fontSize: 10,
			})
		})
		body.push(dados)
	})
	return body
}

export async function imprimirRomaneio(venda: Venda, qrData: string): Promise<void> {
	const valeTrocaBase64: string = await gerarRomaneio(venda, qrData)
	return new Promise((resolve, reject) => {
		print({
			printable: valeTrocaBase64,
			type: 'pdf',
			base64: true,
			onError: reject,
			onLoadingEnd: resolve,
		})
	})
}

function buildLinhasDeVolume(volumes: string[]): any {
	const listaVolumeRetorno = listaVolumeSplit(volumes).map(element => {
		return element.map((volume) => {
			return 	{ image: textToBase64Barcode(volume)}
		})
	})
	return listaVolumeRetorno
	
	
}

function listaVolumeSplit(volumes: string[]): string[][] {
	const lista: string[][] = []
	let listaAtual: string[] = []

	volumes.forEach(volume => {
		if(listaAtual.length < 5)
			listaAtual.push(volume)
		else {
			lista.push(listaAtual)
			listaAtual = []
			listaAtual.push(volume)
		}
	})
	lista.push(listaAtual)
	return lista
}
